export const pushEcommerce = (data) => {
    try {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push(data);
    } catch (e) {
      console.log(e);
    }
  };
  
  export const dataLayerAddToCart = (gtmEcommerceItems) => {
    try {
      pushEcommerce({
        'event': 'gtm_add_to_cart',
        'ecommerce': {
          'items': gtmEcommerceItems,
          'currency': gtmEcommerceItems[0]?.currency,
          'value': gtmEcommerceItems.reduce(
            (p, v) => p + (v.price ?? 0) * (v.quantity ?? 0),
            0
          ),
        },
      });
    } catch (e) {
      console.log(e);
    }
  };

  export const dataLayerViewItemList = (gtmEcommerceItems) => {
    try {
      pushEcommerce({
        'event': 'gtm_view_item_list',
        'ecommerce': {
          'items': gtmEcommerceItems,
          'item_list_id': "",
          'item_list_name': ""
        },
      });
    } catch (e) {
      console.log(e);
    }
  };

  export const dataLayerRemoveFromCart = (gtmEcommerceItems) => {
    try {
      pushEcommerce({
        'event': 'gtm_remove_from_cart',
        'ecommerce': {
          'items': gtmEcommerceItems,
          'currency': gtmEcommerceItems[0]?.currency,
          'value': gtmEcommerceItems.reduce(
            (p, v) => p + (v.price ?? 0) * (v.quantity ?? 0),
            0
          ),
        },
      });
    } catch (e) {
      console.log(e);
    }
  };
  
  export const dataLayerGtmViewCart = (cart) => {
    try {
      pushEcommerce({
        'event': 'gtm_view_cart',
        'ecommerce': {
          'currency': cart.currency,
          'value': cart.gtmGrandTotal,
          'items': cart.gtmOrderRows,
        },
      });
    } catch (e) {
      console.log(e);
    }
  };


  export const dataLayerSearch = (query) => {
  try {
    pushEcommerce({
      event: 'site_search',
      search_term: query,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerFilterSelected = (filter) => {
  try {
    pushEcommerce({
      event: 'filter_selected',
      filter_name: filter,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerFilterDeselected = (filter) => {
  try {
    pushEcommerce({
      event: 'filter_deselected',
      filter_name: filter,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerFiltersCleared = () => {
  try {
    pushEcommerce({
      event: 'filters_cleared',
    });
  } catch (e) {
    console.log(e);
  }
};


export const dataLayerMegaMenuOpened = (menuName) => {
  try {
    pushEcommerce({
      event: 'megamenu_opened',
      menu_name: menuName, // e.g., "Men", "Sale", "Brands"
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerSortOptionChanged = (sortOption, pageType) => {
  try {
    pushEcommerce({
      event: 'sortoption_changed',
      sort_option: sortOption, // e.g., "price_asc", "popularity", "newest"
      page_type: pageType,     // e.g., "category", "search"
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerItemsPerPage = (itemsPerPage) => {
  try {
    pushEcommerce({
      event: 'items_per_page_changed',
      items_per_page: itemsPerPage
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerViewModeChanged = (viewMode) => {
  try {
    pushEcommerce({
      event: 'productlist_viewmode_changed',
      view_mode: viewMode, // e.g., "grid", "list", "compact"
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerAddToFavourites = (productId, productName, category) => {
  try {
    pushEcommerce({
      event: 'added_to_favourites',
      product_id: productId,
      product_name: productName,
      product_category: category,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerRemoveFromFavourites = (productId, productName, category) => {
  try {
    pushEcommerce({
      event: 'removed_from_favourites',
      product_id: productId,
      product_name: productName,
      product_category: category,
    });
  } catch (e) {
    console.log(e);
  }
};
